import { useListState } from '@mantine/hooks';
import { useState, useEffect } from 'react';
import { AgencyTemplateDTO } from '../../Types/MessageT';
import { AgencyTemplateS } from '../AgencyTemplateS';

// eslint-disable-next-line import/prefer-default-export
export const useAgencyTemplates = () => {
  const [templates, handlers] = useListState<AgencyTemplateDTO>([]);
  const [loading, setLoading] = useState(false);
  const { setState, applyWhere } = handlers;
  const { length } = templates;
  const isEmpty = !loading && length === 0;

  useEffect(() => {
    setLoading(true);
    AgencyTemplateS.getAll()
      .then(setState)
      .finally(() => setLoading(false));
  }, [setState]);

  const handleChange = (id: string, patch: Partial<AgencyTemplateDTO>) =>
    applyWhere(
      (item) => item.id === id,
      (item) => ({ ...item, ...patch }),
    );

  return { templates, loading, handlers, isEmpty, handleChange };
};
